import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectDocumentsFetchStatus = createSelector(
  [(store: RootState) => store.supervisorHome.documentsFetchStatus],
  (data) => data
);
